// CSS imports
import './styles/aboutus.css';

// JavaScript imports
import { setupLanguage, selectedLanguage, eventTypesTranslate, layersTranslation, setAboutUsPageLayoutTranslate, infoWeProvideListTranslaiton, dataEntryTranlsation } from "./utils/translation";


// Load javascript file..
window.onload = async function () {

    // from translation.js

    var footer = document.getElementById('footer');
    // Set the footer's styles back to the default.
    footer.style.textAlign = 'left';
    footer.style.direction = 'ltr';

    // set layout direction based on selected language
    setAboutUsPageLayoutTranslate();

    // document.body.style.textAlign = selectedLanguage === 'ar' ? 'right' : 'left';
    // document.body.style.direction = selectedLanguage === 'ar' ? 'rtl' : 'ltr';


    var infoWeProvideList = infoWeProvideListTranslaiton[selectedLanguage];
    let infoElements = infoWeProvideList.map(item => `<li>${item}</li>`).join('');
    let ulElement = document.getElementById('info-weprovide-list');
    ulElement.innerHTML = infoElements;

    var dataEntryTypes = dataEntryTranlsation[selectedLanguage];
    let eventTypesElements = dataEntryTypes.map(item => `<li>${item}</li>`).join('');
    let ulEventTypesElement = document.getElementById('event-weprovide-list');
    ulEventTypesElement.innerHTML = eventTypesElements;

}
